import { useState } from "react";
import { Button, Chip, Stack } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, useNotify, useRecordContext, useRefresh } from "react-admin";

import { adminApi } from "../../dataProvider";
import { accrualStatus } from "../partners/status";

type AccrualRecord = {
  id: string;
  level: "L1" | "L2";
  model: string;
  turnover_rub: number;
  rate: number;
  rate_pct: number;
  amount_usd: number;
  status: string;
  needs_review: boolean;
  available_at: string | null;
  partner_id: string;
};

function StatusChip() {
  const record = useRecordContext<AccrualRecord>();
  if (!record) return null;
  const s = accrualStatus(record.status);
  return (
    <Stack direction="row" spacing={0.5}>
      <Chip size="small" color={s.color} label={s.label} />
      {record.needs_review && <Chip size="small" color="error" label="Проверка" />}
    </Stack>
  );
}

// Разбор помеченных антифродом начислений: подтвердить (пойдёт из холда по сроку) или отменить.
function ReviewActions() {
  const record = useRecordContext<AccrualRecord>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [busy, setBusy] = useState(false);
  if (!record || !record.needs_review) return null;

  const call = async (action: "approve" | "cancel") => {
    setBusy(true);
    try {
      await adminApi(`/admin/accruals/${record.id}/${action}`, { method: "POST" });
      notify("Готово", { type: "success" });
      refresh();
    } catch (e) {
      notify(e instanceof Error ? e.message : "Ошибка", { type: "error" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Stack direction="row" spacing={1}>
      <Button size="small" disabled={busy} onClick={() => call("approve")}>Подтвердить</Button>
      <Button size="small" color="error" disabled={busy} onClick={() => call("cancel")}>Отменить</Button>
    </Stack>
  );
}

export function AccrualList() {
  return (
    <List perPage={50} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <DateField source="created_at" label="Дата" showTime />
        <FunctionField label="Статус" render={() => <StatusChip />} />
        <FunctionField source="level" label="Уровень" render={(r: AccrualRecord) => r.level} />
        <FunctionField
          label="Оборот сделки"
          render={(r: AccrualRecord) => `${Number(r.turnover_rub).toLocaleString("ru-RU")} ₽`}
        />
        <FunctionField label="Ставка" render={(r: AccrualRecord) => `${Number(r.rate_pct)}%`} />
        <FunctionField label="Начислено" render={(r: AccrualRecord) => `${Number(r.amount_usd).toFixed(2)} $`} />
        <DateField source="available_at" label="Доступно с" showTime />
        <FunctionField label="" render={() => <ReviewActions />} />
      </Datagrid>
    </List>
  );
}
